<template>
  <svg
    width="120"
    height="120"
    viewBox="0 0 343 343"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_14469_77078)">
      <path
        d="M132.023 287.991C134.166 292.35 132.37 297.621 128.012 299.764C123.653 301.908 118.382 300.112 116.239 295.754C114.095 291.395 115.891 286.124 120.249 283.98C124.608 281.837 129.879 283.633 132.023 287.991Z"
        fill="#462170"
      />
      <path
        d="M127.927 288.568C127.927 288.568 128.717 291.62 124.76 293.566C120.741 295.543 118.807 293.053 118.807 293.053L112.654 284.02"
        stroke="#462170"
        stroke-width="3.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M194.636 298.933C197.839 295.281 197.475 289.725 193.824 286.522C190.173 283.319 184.616 283.682 181.413 287.333C178.21 290.985 178.573 296.541 182.225 299.744C185.876 302.948 191.433 302.584 194.636 298.933Z"
        fill="#462170"
      />
      <path
        d="M224.445 295.161C225.492 290.418 222.496 285.724 217.753 284.677C213.01 283.63 208.316 286.626 207.269 291.369C206.222 296.112 209.218 300.805 213.961 301.853C218.704 302.9 223.398 299.904 224.445 295.161Z"
        fill="#462170"
      />
      <path
        d="M155.658 298.396C159.093 294.961 159.093 289.393 155.658 285.958C152.224 282.524 146.655 282.524 143.221 285.958C139.786 289.393 139.786 294.961 143.221 298.396C146.655 301.831 152.224 301.831 155.658 298.396Z"
        fill="#462170"
      />
      <path
        d="M121.584 271.007C119.694 271.243 117.969 269.903 117.733 268.013L100.912 133.66C100.675 131.769 102.016 130.045 103.906 129.808C105.796 129.572 107.521 130.912 107.757 132.803L124.578 267.156C124.815 269.046 123.474 270.77 121.584 271.007Z"
        fill="#462170"
      />
      <path
        d="M157.416 265.695C155.526 265.932 153.801 264.591 153.565 262.701L136.744 128.348C136.507 126.458 137.848 124.733 139.738 124.497C141.628 124.26 143.353 125.601 143.589 127.491L160.41 261.844C160.647 263.734 159.306 265.459 157.416 265.695Z"
        fill="#462170"
      />
      <path
        d="M191.426 261.392C189.536 261.629 187.811 260.288 187.575 258.398L170.754 124.045C170.517 122.155 171.858 120.43 173.748 120.194C175.638 119.957 177.363 121.297 177.599 123.188L194.42 257.541C194.657 259.431 193.316 261.155 191.426 261.392Z"
        fill="#462170"
      />
      <path
        d="M200.875 158.247L213.01 255.175C214.28 265.316 207.088 274.565 196.948 275.835L122.328 285.177C112.187 286.447 102.938 279.256 101.668 269.115L84.1453 129.155C82.8757 119.015 90.0669 109.765 100.207 108.496L174.828 99.1531C184.968 97.8835 194.217 105.075 195.487 115.215L201.868 166.185"
        stroke="#462170"
        stroke-width="3.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M155.052 101.629H136.043C131.829 101.629 127.947 103.04 124.836 105.412L155.052 101.629Z"
        stroke="#462170"
        stroke-width="3.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M186.607 101.629C191.328 104.451 194.75 109.335 195.486 115.215L201.868 166.185"
        stroke="#462170"
        stroke-width="3.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M219.299 119.228C218.803 108.987 210.127 101.084 199.919 101.578L186.607 101.629L186.611 101.644C191.326 104.467 194.75 109.339 195.486 115.215L201.867 166.185L200.874 158.246L213.009 255.175C214.279 265.316 207.088 274.565 196.947 275.835L190.372 276.658L188.024 279.69L208.552 280.029C218.76 279.536 226.633 270.832 226.137 260.591L219.299 119.228Z"
        stroke="#462170"
        stroke-width="3.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M122.328 285.177C112.187 286.447 102.938 279.256 101.668 269.115L84.1453 129.155C82.8757 119.015 90.0669 109.765 100.207 108.496L174.828 99.1531C184.968 97.8835 194.217 105.075 195.487 115.215"
        stroke="#B1A8D3"
        stroke-width="18"
        stroke-linejoin="round"
      />
      <path
        d="M278.505 233.84L275.987 235.662C269.363 237.402 263.517 242.374 261.36 248.874L256.91 252.252"
        stroke="#462170"
        stroke-width="3.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M239.902 189.648C243.94 193.416 246.589 198.433 250.318 202.507C250.87 203.109 251.465 203.704 252.216 204.025C253.067 204.388 254.028 204.361 254.952 204.294C261.022 203.855 266.981 201.942 272.172 198.766C274.152 197.555 276.161 196.115 278.481 196.023C281.434 195.906 283.966 197.986 286.179 199.946C289.57 202.951 292.962 205.955 296.353 208.959C291.814 218.14 282.712 224.504 278.505 233.84C276.631 232.361 273.911 232.899 271.649 233.661C267.748 234.974 263.917 236.802 261.031 239.736C258.145 242.671 256.321 246.865 256.996 250.925C257.071 251.374 257.164 251.875 256.91 252.252C256.751 252.486 256.487 252.623 256.234 252.749C248.268 256.74 240.302 260.73 232.336 264.721C232.019 264.88 231.67 265.043 231.323 264.969C230.983 264.897 230.734 264.615 230.511 264.348C226.775 259.868 223.43 255.06 220.527 250C226.424 249.504 231.591 244.381 232.136 238.488C230.369 238.786 229.229 236.706 228.698 234.994C227.239 230.285 226.022 225.502 225.054 220.668C224.394 217.376 223.838 214.021 222.445 210.966C221.052 207.911 218.674 205.13 215.48 204.097C212.285 203.064 209.604 202.518 208.135 205.536C211.52 198.582 217.033 193.383 222.544 188.058C227.662 183.114 234.988 185.062 239.902 189.648Z"
        fill="white"
        stroke="#462170"
        stroke-width="3.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M229.903 311.001C230.156 310.543 230.417 310.183 230.417 310.183C233.144 307.351 236.226 304.838 239.559 302.729C241.093 301.757 242.647 300.895 244.937 301.184C245.149 301.211 245.375 301.116 245.577 301.019C246.074 300.78 246.304 300.224 246.559 299.746C246.81 299.277 249.199 297.567 249.724 297.481C250.259 297.393 250.859 297.354 251.245 296.961C251.402 296.801 251.565 296.618 251.608 296.409C252.073 294.147 253.39 292.954 254.804 291.815C257.874 289.341 261.248 287.233 264.807 285.564C264.807 285.564 265.232 285.433 265.747 285.341C266.262 285.25 266.849 285.5 266.912 285.989C266.993 286.629 266.231 287.112 265.894 287.707C265.443 288.505 265.806 289.43 266.246 290.154C266.803 291.07 267.475 291.911 268.007 292.841C268.539 293.772 268.931 294.823 268.864 295.932C268.779 297.327 267.979 298.655 267.04 299.794C265.31 301.894 262.98 303.597 260.382 304.365C259.396 304.657 258.354 304.813 257.387 304.624C255.609 304.276 254.381 302.85 253.387 301.43C252.917 300.759 252.914 300.696 252.228 300.231C251.352 299.639 248.077 301.983 248.356 303.003C248.574 303.802 248.633 303.825 249.117 304.487C250.141 305.886 251.095 307.508 250.851 309.302C250.719 310.279 250.235 311.215 249.641 312.055C248.077 314.266 245.713 315.922 243.168 316.884C241.787 317.405 240.272 317.734 238.924 317.365C237.852 317.071 236.984 316.361 236.274 315.558C235.564 314.755 234.985 313.847 234.298 313.025C233.754 312.375 232.996 311.733 232.095 311.903C231.423 312.03 230.72 312.596 230.141 312.312C229.698 312.095 229.65 311.459 229.903 311.001Z"
        stroke="#462170"
        stroke-width="3.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M105.159 46.8489L107.446 46.624C109.627 46.4095 111.221 44.4675 111.007 42.2863C110.792 40.1051 112.387 38.1631 114.568 37.9486L154.691 33.9565C156.872 33.7421 158.814 35.3364 159.028 37.5176C159.243 39.6988 161.185 41.2931 163.366 41.0787L165.629 40.8562C167.705 40.6521 169.267 38.8798 169.209 36.7945C169.094 32.6425 168.768 26.4949 163.294 27.0331C156.03 27.7473 110.027 32.3176 104.377 32.8731C100.115 33.2921 100.512 39.099 100.815 43.22C100.977 45.4328 102.951 47.0659 105.159 46.8489Z"
        fill="#462170"
      />
      <path
        d="M112.09 99.913L106 45.1689"
        stroke="#462170"
        stroke-width="3.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M170.09 92.913L164 38.1689"
        stroke="#462170"
        stroke-width="3.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_14469_77078">
        <rect width="343" height="343" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
